import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=d52f11c2&scoped=true&"
import script from "./QR.vue?vue&type=script&lang=js&"
export * from "./QR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52f11c2",
  null
  
)

export default component.exports